/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GeneralInfoTab } from '@/app/(client)/network/-components/companyProfileTabs/generalInformation/GeneralInfoTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';

const searchSchema = z.object({
  genTemplate: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/general-info',
)({
  validateSearch: searchSchema,
  component: GeneralInfoRoute,
});

function GeneralInfoRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  return <GeneralInfoTab companyId={companyId} company={company} />;
}
